import { CompanyPermissions } from './CompanyPermissionsInterface';

/**
 * Maps API permission strings to CompanyPermissions interface
 */
export function mapPermissionsToUIPermissions(permissions: string[] = []): CompanyPermissions {
  const hasPermission = (permission: string) => permissions.includes(permission);

  return {
    // Company
    canEditCompany: hasPermission('COMPANY_UPDATE'),
    canEditBillingInfo: hasPermission('EDIT_BILLING_INFO') || hasPermission('COMPANY_UPDATE'),
    canSendBankInfoReminder:
      hasPermission('COMPANY_SEND_BANK_INFO_REMINDER') ||
      hasPermission('EDIT_BILLING_INFO') ||
      hasPermission('COMPANY_UPDATE'),
    canEditCompanyUsers: hasPermission('COMPANY_USERS_UPDATE'),

    // Locations
    canCreateLocations: hasPermission('LOCATIONS_CREATE'),
    canEditLocations: hasPermission('LOCATIONS_UPDATE'),

    // Chargers
    canCreateChargers: hasPermission('CHARGERS_CREATE'),
    canEditChargers: hasPermission('CHARGERS_UPDATE'),
    canTriggerChargingSessions: hasPermission('TRANSACTIONS_START_FREE'),
    canRebootChargers: hasPermission('CHARGERS_RESET'),
    canUseSparkChargerAnalysis: hasPermission('CHARGERS_ANALYZE_WITH_SPARK'),
    canViewChargerSparkSignals: hasPermission('CHARGERS_ANALYZE_WITH_SPARK'),
    canViewChargerWifiPasswords: hasPermission('CHARGERS_VIEW_WIFI_PASSWORDS'),
    canGetChargerOcppMessages: hasPermission('CHARGERS_GET_OCPP_MESSAGES_MASKED'),
    canViewSupportNotes: hasPermission('SUPPORT_NOTES_READ'),
    canEditSupportNotes: hasPermission('SUPPORT_NOTES_UPDATE'),
    canMoveChargers: hasPermission('CHARGERS_UPDATE'),
    canDeleteChargers: hasPermission('CHARGERS_DELETE'),

    // Power Management
    canViewPowerManagement: hasPermission('POWER_MANAGEMENT_READ'),
    canManagePowerManagement: hasPermission('POWER_MANAGEMENT_MANAGE'),

    // Access Rules
    canViewAccessRules: hasPermission('CHARGER_ACCESS_RULES_READ'),
    canCreateAccessRules: hasPermission('CHARGER_ACCESS_RULES_MODIFY'),
    canEditAccessRules: hasPermission('CHARGER_ACCESS_RULES_MODIFY'),
    canDeleteAccessRules: hasPermission('CHARGER_ACCESS_RULES_MODIFY'),

    // Terminals
    canCreateTerminals: hasPermission('PAYMENT_TERMINALS_CREATE'),
    canEditTerminals: hasPermission('PAYMENT_TERMINALS_UPDATE'),
    canDeleteTerminals: hasPermission('PAYMENT_TERMINALS_DELETE'),

    canViewVehicles: hasPermission('VEHICLES_READ'),
    canCreateVehicles: hasPermission('VEHICLES_ADD') || hasPermission('VEHICLES_CREATE'),
    canEditVehicles: hasPermission('VEHICLES_UPDATE'),
    canDeleteVehicles: hasPermission('VEHICLES_DELETE'),

    // Pricing Rules & Discounts
    canCreatePricingRules: hasPermission('PRICE_MODEL_CREATE'),
    canViewPriceModels: hasPermission('PRICE_MODEL_READ'),
    canEditPricingRules: hasPermission('PRICE_MODEL_UPDATE'),
    canDeletePricingRules: hasPermission('PRICE_MODEL_DELETE'),
    canCreateDiscounts: hasPermission('PRICE_ADJUSTMENT_CREATE'),
    canEditDiscounts: hasPermission('PRICE_ADJUSTMENT_UPDATE'),
    canDeleteDiscounts: hasPermission('PRICE_ADJUSTMENT_DELETE'),
    canViewPricing: hasPermission('PRICE_MODEL_READ'),

    // RFID Cards
    canViewRfidCards: hasPermission('COMPANY_RFIDS_READ'),
    canRegisterRfidCards: hasPermission('COMPANY_RFIDS_REGISTER'),
    canEditRfidCards: hasPermission('COMPANY_RFIDS_REGISTER'),
    canDeleteRfidCards: hasPermission('COMPANY_RFIDS_UNREGISTER'),

    // Licenses
    canCreateLicenses: hasPermission('LICENSES_CREATE'),
    canEditLicenses: hasPermission('LICENSES_UPDATE'),
    canDeleteLicenses: hasPermission('LICENSES_DELETE'),

    // Finances
    canViewFinances: hasPermission('COMPANY_FINANCES_READ'),

    // Promotions
    canViewPromotion: hasPermission('PRICE_MODEL_READ'),
    canCreatePromotion: hasPermission('PRICE_ADJUSTMENT_CREATE'),
  };
}
